{
  "background": {
    "background-default": "#fafafa",
    "background-subtle": "#f5f5f5"
  },
  "surface": {
    "surface-default": "#ffffff",
    "surface-raised": "#ffffff",
    "surface-sunken": "#f5f5f5"
  },
  "text": {
    "text-default": "#0e1113",
    "text-muted": "#495054",
    "text-subtle": "#888f92",
    "text-inverse": "#ffffff",
    "text-link": "#002664"
  },
  "border": {
    "border-default": "#dcdfe0",
    "border-subtle": "#ebebeb",
    "border-strong": "#888f92"
  },
  "action": {
    "action-default": "#002664",
    "action-hover": "#001037",
    "action-subtle": "#f0fbff"
  },
  "success": {
    "success-surface": "#eff9ed",
    "success-text": "#005a02",
    "success-border": "#8fc78a",
    "success-solid": "#008a07"
  },
  "warning": {
    "warning-surface": "#fff3ed",
    "warning-text": "#882f03",
    "warning-border": "#eea88a",
    "warning-solid": "#c95000"
  },
  "danger": {
    "danger-surface": "#fff0ef",
    "danger-text": "#7c061f",
    "danger-border": "#ea9294",
    "danger-solid": "#b81237"
  },
  "info": {
    "info-surface": "#e9eef7",
    "info-text": "#193366",
    "info-border": "#8098c2",
    "info-solid": "#2e5299"
  }
}
